<template>
<v-menu v-model="menuGateway" offset-y lazy :close-on-content-click="false">
  <template v-slot:activator="{ on }">
    <v-btn flat v-on="on" style="min-width:24px;">
      <div>
        <v-icon :small="available">router</v-icon><br>
        <span v-if="available">{{(userMacInfo[$root.searchGateway]||{}).hostname||$root.searchGateway}}</span>
      </div>
    </v-btn>
  </template>
  <gateway-selector solo v-model="$root.searchGateway" :label="$t('device.filter_by_gateway')" clearable style="max-width:280px"></gateway-selector>
</v-menu>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import GatewaySelector from '@/components/gateway/GatewaySelector'

export default {
  name: 'SearchGatewayMenu',
  mixins: [UserAuth],
  components: {
    'gateway-selector': GatewaySelector
  },
  data() {
    return {
      menuGateway: false
    }
  },
  computed: {
    available() {
      return !this.menuGateway && !!this.$root.searchGateway;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/SearchGatewayMenu.vue